
<form  [formGroup]="searchRoleForm" *ngIf="roleGroup.server_role_group_id!=0">
  <table class="table table-striped">

      <tr><td>Name</td><td>{{roleGroup.name}}</td></tr>
      <tr><td>Description</td><td>{{roleGroup.userCount}}</td></tr>
      <tr><td colspan="2">
          <ul>
          <li *ngFor="let user of roleGroup.users;">
           {{user}}
          </li>
    </ul>
  </td>

  </tr>


  </table>

    <div class="row">
          <div class="col-sm-4" > Search User</div>
          <div class="col-sm-4" ><input   formControlName="searchInput" class="form-control"/></div>
    </div>
    <ul>
          <li *ngFor="let user of userList;" style="list-style: none;">
             <button (click)="addUser(user.id)" class="mt-1 btn-primary"> Add User</button> {{user.text}}
          </li>
    </ul>
    </form>

